import Component from "../component.abstract";

export default class HomeP3 extends Component {
  private timedone = false;
  private lazyComponents = [
    "[data-messages]",
    "[data-serp]",
    "[data-alerte-home]",
    "[data-candidatures-home]",
  ];
  private readyComponents: HTMLElement[] = [];
  private lazyTimeout: NodeJS.Timeout;

  constructor(private props: unknown, element: HTMLElement) {
    super(props, element);
  }

  mounted(): void {
    // Initialize the lazy components
    for (let i = 0; i < this.lazyComponents.length; i++) {
      const lazyComponent = document.querySelector(this.lazyComponents[i]);
      lazyComponent.classList.add("global-lazy-loading");
      lazyComponent.addEventListener("ready", this.addReady.bind(this));
    } 
  }
  addReady(event: Event): void {
    if (this.timedone) {
      // If time is done, display the component
      event.target.dispatchEvent(new CustomEvent("display"));
      this.readyComponents.push(<HTMLElement>event.target);
    } else {
      // Launch the timeout once the first component is ready
      if (!this.readyComponents.length) {
        this.lazyTimeout = setTimeout(
          this.displayReadyComponents.bind(this),
          2000
        );
      }

      // Add the component to the waiting line
      this.readyComponents.push(<HTMLElement>event.target);

      // If all the components are ready, display them
      if (this.readyComponents.length === this.lazyComponents.length) {
        this.displayReadyComponents();
      }
    }

     // When all components are displayed, scroll on mobile
     if (this.readyComponents.length === this.lazyComponents.length && window.innerWidth < 767) {
            this.element.scrollIntoView();
            window.scrollBy(0, -44); // Header offset
     }
  }
  displayReadyComponents():void {
       clearTimeout(this.lazyTimeout);
       this.timedone = true;

       for (let i = 0; i < this.readyComponents.length; i++) {
         this.readyComponents[i].dispatchEvent(new CustomEvent("display"));
       }
  }
}
